/* eslint-disable no-empty */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWebBuildVersion } from '../../actions/app-actions-types';

const BuildVersionCheck = () => {
  const dispatch = useDispatch();
  let { lastBuildCheckTime = 0 } = useSelector((state: any) => state.app);

  const refreshCacheAndReload = () => {
    try {
      if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then(function (names) {
          for (let name of names) caches.delete(name);
        });
      }
      // delete browser cache and hard reload
      // window.location.reload();
    } catch (error) {}
  };

  useEffect(() => {
    const currentTimeStamp = new Date().getTime();
    if (lastBuildCheckTime > 0 && currentTimeStamp - lastBuildCheckTime > 60000) {
      // 60000 miliseconds === 1 minute
      dispatch(
        getWebBuildVersion({
          callback: ({ result = {}, error }: any) => {
            if (!error) {
              const { version = 0 } = result;
              if (parseInt(version) > parseInt(window?.BUILD_VERSION)) {
                // dispatch(showToast('Installing updates...'));
                refreshCacheAndReload();
              }
            }
          }
        })
      );
    }
  }, []);

  return null;
};

export default BuildVersionCheck;
